var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscriptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Subscriptions"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Subscriptions",
    clipPath: "url(#clip-Subscriptions)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Light-Outline_Bookmark",
    "data-name": "Iconly/Light-Outline/Bookmark",
    transform: "translate(2 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bookmark",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M8.012,0c2.323,0,3.655,1.15,3.655,3.153v9.953a1.164,1.164,0,0,1-1.735,1.013L5.851,11.814l-4.119,2.31A1.164,1.164,0,0,1,0,13.109V3.027C0,1.1,1.333,0,3.658,0Zm0,1.027H3.658c-1.745,0-2.631.672-2.631,2V13.109a.129.129,0,0,0,.068.117.128.128,0,0,0,.136,0L5.6,10.776a.516.516,0,0,1,.5,0l4.332,2.447a.128.128,0,0,0,.136,0,.131.131,0,0,0,.067-.118V3.074C10.635,2.485,10.521,1.027,8.012,1.027Zm.3,3.58a.514.514,0,1,1,0,1.027H3.3a.514.514,0,1,1,0-1.027Z",
    transform: "translate(0 0)",
    fill: "#a2a2a2",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptions);
export default __webpack_public_path__ + "static/media/Subscriptions.c10f4f66b9cc72a15f77fd585a391d04.svg";
export { ForwardRef as ReactComponent };